<template>
  <el-form :model="value" ref="refForm" class="EvaluateForm" show-message :label-position="labelPosition" :hide-required-asterisk="hideRequiredAsterisk" :label-width="labelWidth">
    <el-form-item
      v-for="(item, index) in options"
      :key="item.prop + '' + index"
      :label="item.label"
      :rules="item.rules"
      :prop="item.prop"
      :label-width="item.labelWidth"
    >
      <div v-if="item.type === 'slot'">
        <slot name="self" :config="item"></slot>
      </div>
      <div v-else-if="item.type === 'text'">
        <div v-html="item.format ? item.format(value[item.prop], data) : (getRealProp(item.showTextProp || item.prop) || '--')"></div>
      </div>
      <component
        v-else-if="item.type"
        :is="item.type"
        :editable="editable"
        v-model="value[item.prop]"
        :form="value"
        :data="data"
        v-bind="{
          ...item.propOptions
        }"
        :propOptions="item.propOptions"
        @input="clearValidate(item.prop)"
      >
        <template v-if="item.type === 'el-select' && item.propOptions">
          <el-option
            v-for="opt in item.propOptions.options"
            :key="opt[item.propOptions.valueKey || 'value'] || opt[item.propOptions.labelKey || 'label']"
            :label="opt[item.propOptions.labelKey || 'label']"
            :disabled="opt.disabled"
            :value="opt[item.propOptions.valueKey || 'value']">
            {{ opt['showLabel'] || opt[item.propOptions.labelKey || 'label'] }}
          </el-option>
        </template>
      </component>
      <div v-else v-html="item.format ? item.format(value[item.prop], data) : value[item.prop]"></div>
    </el-form-item>
  </el-form>
</template>

<script>
import ButtonTab from './ButtonTab';
import EditInput from './EditInput';
import Tags from './Tags';
import Upload from './Upload';
import Type from './Type';
import SelectTag from './SelectTag';
export default {
  components: { ButtonTab, EditInput, Tags, Upload, Type, SelectTag },
  props: {
    value: Object,
    data: Object,
    options: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: true
    },
    hideRequiredAsterisk: Boolean,
    labelWidth: String,
    labelPosition: String,
  },
  methods: {
    getRealProp(propStr) {
      return propStr.split('.').reduce((o, p) => o && o[p], this.data)
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs['refForm'].validate((vaild, error) => {
          if (vaild) {
            resolve(true)
          } else {
            this.$message.error(Object.values(error)[0][0].message)
            reject(false)
          }
        })
      })
    },
    clearValidate (prop) {
      this.$refs['refForm']?.clearValidate(prop)
    }
  }
}
</script>

<style lang="scss">
.EvaluateForm {
  font-size: 13px;
  color: #101010;
  &.el-form .el-form-item .el-form-item__label {
    font-size: 14px;
    color: #101010;
    padding-right: 0;
  }
}
</style>